// import Header from '../components/header/Header';
import { useTranslation } from 'react-i18next';
import './policy.scss'

const Policy: React.FC = () => {
    const { t } = useTranslation();
    return (
        <section className='policy'>
            <h1 className='policy__header'>{t("privacyPolicy.general.title")}</h1>
            <ol>
                <li>{t("privacyPolicy.general.subtitle")}<br />
                    {t("privacyPolicy.general.text")}
                    <ol>
                        <li>{t("privacyPolicy.general.items.item1")}</li>
                        <li>{t("privacyPolicy.general.items.item2")}</li>
                    </ol>
                </li>
                <li>{t("privacyPolicy.personalData.title")}
                    <ol>
                        <li>{t("privacyPolicy.personalData.items.item1")}</li>
                        <li>{t("privacyPolicy.personalData.items.item2")}</li>
                        <li>{t("privacyPolicy.personalData.items.item3")}</li>
                    </ol>
                </li>
                <li>{t("privacyPolicy.thirdPartyServices.title")}
                    <ol>
                        <li>{t("privacyPolicy.thirdPartyServices.items.item1")}</li>
                        <li>{t("privacyPolicy.thirdPartyServices.items.item2")}<a href="https://yandex.ru/legal/confidential"> https://yandex.ru/legal/confidential</a></li>

                    </ol>
                </li>
                <li>{t("privacyPolicy.safety.title")}
                    <ol>
                        <li>{t("privacyPolicy.safety.items.item1")}
                        </li>
                    </ol>
                </li>
                <li>{t("privacyPolicy.finalProvisions.title")}
                    <ol>
                        <li>{t("privacyPolicy.finalProvisions.items.item1")}</li>
                    </ol>
                </li>
            </ol>
        </section>

    )
}

export default Policy;